/* Helper function for styling logs based on the log type.
 * This function will inspect the log entry and format the log
 * accordingly.
 */
function styleLog (entry) {
  const { timestamp, level } = entry
  const logInfo = `${timestamp} - ACTION - ${level}`

  let [logType, payload] = entry.messages

  let prefix
  let style = ''
  if (logType.includes('state')) {
    // If the log is for prev state / next state, display that in the prefix.
    prefix = `${logInfo} - ${logType.toUpperCase()}`
  } else if (logType.includes('ADDED') || logType.includes('DELETED') || logType.includes('ARRAY')) {
    // If the log has added or removed keys from state, log the operation, keys affected and new values.
    prefix = `${entry.messages[0]}: ${entry.messages[2]}`
    style = entry.messages[1]
    payload = entry.messages[3]
  } else if (logType.includes('CHANGED')) {
    // If the log has changed keys in state, log the operation, keys, old and new values.
    prefix = `${entry.messages[0]}: ${entry.messages[2]}`
    style = entry.messages[1]
    payload = `${entry.messages[3]} ${entry.messages[4]} ${entry.messages[5]}`
  } else if (logType.includes('no diff')) {
    // If action results in no change in state, just log no diff.
    prefix = `${logInfo} - NO DIFF`
    payload = ''
  } else {
    // Else the log is the action itself, so use the action type.
    prefix = `${logInfo} - ${payload.type} - ${logType}`
  }

  return { prefix, style, payload }
}

/**
 * Default function for the SDK to use for logging actions.
 * Action entries come in 4 different types:
 *    1. start: Log the message directly and "open the group".
 *    2. state: Log a prefix, state type, and state itself.
 *      (prev state and next state)
 *    3. payload: Log a prefix, action type, and payload.
 *    4. end: Close the group.
 * @method defaultActionHandler
 * @param  {LogEntry} entry
 */
export default function defaultActionHandler (entry) {
  // Handle the "start" and "stop" action log entries specifically.
  if (['group', 'groupCollapsed'].includes(entry.method)) {
    console[entry.method](...entry.messages)
    return
  } else if (entry.method === 'groupEnd') {
    console.groupEnd()
    return
  }

  const { prefix, style, payload } = styleLog(entry)
  console[entry.method](prefix, style, payload)
}
